import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-move-to-next-workflow-state-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class TaskMoveToNextWorkflowStateApiManualV2Component extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.moveTaskToNextWorkflowState"),
            description: this.translation.t("specs.moveTaskToNextWorkflowStateDescription"),
            httpMethod: "POST",
            path: "/taskdata/v2/task/{guid}/workflow/advance",

            parameters: [
                {
                    name: "guid",
                    description: this.translation.t("parameters.updateTaskScoreAndStatusGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "comment",
                    description: this.translation.t("parameters.moveTaskToNextWorkflowStateCommentDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "comment to add to the task",
                }
            ],

            responses: [
                {
                    code: "200",
                    description: "OK"
                }
            ]
        }
    }
}
